export const CONTAINER_ANIMATION_DURATION = 200
export const ICON_ANIMATION_DURATION = 100
export const ANIMATION_DURATION = CONTAINER_ANIMATION_DURATION + ICON_ANIMATION_DURATION
